module.exports = __webpack_public_path__ + "img/2.38dc9a37.jpg";